module.exports = __webpack_public_path__ + "dc975c3cb8d6bad70b663ea6fe06b5c5.png";